export default function WomenClothingIcon() {
  return (
    <svg viewBox="0 0 187 187" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="93.5" cy="93.0627" r="93.0627" fill="url(#WomenClothingIconGradientFilter)" />
      <path d="M131.168 71.7828C131.168 71.7828 120.515 66.5372 120.515 39.884H109.863C109.863 39.884 106.369 61.1498 93.8693 61.1498C81.37 61.1498 77.8759 39.884 77.8759 39.884H67.2231C67.2231 66.0835 56.5703 71.7828 56.5703 71.7828L72.5637 98.3792L56.5703 146.241H131.14L115.175 98.3792L131.168 71.7828Z" fill="url(#WomenClothingIconClothGradientFilter)" />
      <defs>
        <linearGradient id="WomenClothingIconGradientFilter" x1="93.5" y1="0" x2="93.5" y2="186.125" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF00CF" stopOpacity="0.13" />
          <stop offset="1" stopColor="#FF0B8F" stopOpacity="0.63" />
        </linearGradient>
        <linearGradient id="WomenClothingIconClothGradientFilter" x1="93.8693" y1="39.884" x2="93.5" y2="146.241" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF5C00" />
          <stop offset="1" stopColor="#FF80C4" stopOpacity="0.35" />
        </linearGradient>
      </defs>
    </svg>
  );
}
